import React from 'react'
import { Link } from 'react-router-dom'
import styles from './Card_3.module.css'

export const Card_3 = () => {
    return (
        <div className={styles.container}>
            <div className={styles.card_header}>
                <h2>Newly Added</h2>
            </div>
            <div className={styles.card_container}>
                {Array(7)
                    .fill()
                    .map((item) => (
                        <div className={styles.card}>
                            <div className={styles.icon_container}>
                                <i class="fas fa-user-circle"></i>
                            </div>
                            <div className={styles.text_container}>
                                <span>
                                    <h2>RDI Solutions</h2>
                                    <Link><p>View</p></Link>    
                                </span>
                                <p>This is just a description of the first test client/project.</p>
                            </div>
                        </div>
                    ))
                }
            </div>
            <div className={styles.card_footer}>
                <button>View All</button>
            </div>
        </div>
    )
}